var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreparingSupplyReqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.77197,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.77197,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#C1CFE0",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.522 29L29.522 34L26.022 30.5L27.522 29L29.522 31L33.022 27.5L34.522 29ZM17.022 14C15.912 14 15.022 14.89 15.022 16V32C15.022 33.11 15.912 34 17.022 34H24.832C24.302 33.09 24.022 32.05 24.022 31C24.022 27.69 26.712 25 30.022 25C30.362 25 30.692 25.03 31.022 25.08V20L25.022 14M24.022 15.5L29.522 21H24.022V15.5Z",
    fill: "#FBB731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreparingSupplyReqIcon);
export default __webpack_public_path__ + "static/media/preparing-supply-req-icon.a2822321d4fc375f84bf4f1e7e2096c3.svg";
export { ForwardRef as ReactComponent };